import React from 'react';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ArrowDownIcon: React.FC<React.PropsWithChildren<unknown>> = () => {
	return <FontAwesomeIcon icon={faCaretDown} />;
};

export default ArrowDownIcon;
